/**
 * The locale, handed down.
 *
 * Unlike the console's provider this holds no state and offers no setter. The
 * locale is a property of the URL — `/tr/` is a Turkish document, `/en/` is an
 * English one, both prerendered — so there is nothing to toggle at runtime and
 * nothing to store. Switching language is a link, because it changes the
 * document.
 *
 * That is also what makes a flash of the wrong language impossible: there is no
 * client-side decision to be made after paint.
 */

import { createContext, useContext, type ReactNode } from 'react'

import { translate, type Locale, type MessageKey } from './index'

const LocaleContext = createContext<Locale>('tr')

export function I18nProvider({ locale, children }: { locale: Locale; children: ReactNode }) {
  return <LocaleContext.Provider value={locale}>{children}</LocaleContext.Provider>
}

export function useLocale(): Locale {
  return useContext(LocaleContext)
}

export function useT() {
  const locale = useContext(LocaleContext)
  return (key: MessageKey, vars?: Record<string, string | number>) =>
    translate(locale, key, vars)
}
